import { useLocation } from 'react-router-dom';

import { useStreams } from 'streams/hooks/useStreams';
import { useTagsFilterParams } from 'tags/hooks/useTagsFilterParams';

type DashboardFilterParams = {
  gateway_id?: string;
  stream_ids?: string[];
};

export function useDashboardFilterParams(): DashboardFilterParams {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const gatewayId = params.get('gateway_id');

  const tagFilters = useTagsFilterParams();
  const isFilteringWithTags =
    tagFilters.tagged_with !== undefined || tagFilters.only_untagged === true;

  const { data: streams } = useStreams({
    params: tagFilters,
    enabled: isFilteringWithTags,
    keepPreviousData: false,
  });

  const streamIds = streams?.data.map(({ id }) => id);

  return {
    gateway_id: gatewayId ?? undefined,
    stream_ids: streamIds,
  };
}
